module.exports = __webpack_public_path__ + "assets/66a09e670dbcf8d25e8c916127e895a1.png";